import React from 'react';

/** Empty inbox: a bell on a quiet hill. */
export function InboxArt() {
  return (
    <svg className="nt-art" viewBox="0 0 420 220" aria-hidden="true">
      <rect className="nt-art__sky" width="420" height="220" rx="28" />
      <circle className="nt-art__sun" cx="346" cy="42" r="16" />
      <circle className="nt-art__cloud" cx="64" cy="48" r="10" />
      <circle className="nt-art__cloud" cx="82" cy="42" r="14" />
      <path className="nt-art__hill" d="M0 140c54-28 90 12 146-6 46-16 72 18 124-2 34-14 58 8 90-8 16-6 36 4 60-10v96H0z" />
      <path className="nt-art__hill2" d="M0 176c70-20 100 16 168-2 50-14 78 14 252-12v58H0z" />
      <path className="nt-art__bell" d="M210 58c-28 0-46 20-46 46v18l-14 18h120l-14-18v-18c0-26-18-46-46-46z" />
      <circle className="nt-art__clapper" cx="210" cy="152" r="8" />
      <circle className="nt-art__badge" cx="246" cy="72" r="12" />
    </svg>
  );
}

export function VideoThumb() {
  return (
    <svg className="nt-thumb__svg" viewBox="0 0 640 200" preserveAspectRatio="xMidYMid slice" aria-hidden="true">
      <rect className="nt-thumb__sky" width="640" height="200" />
      <circle className="nt-thumb__sun" cx="540" cy="36" r="18" />
      <path className="nt-thumb__hill" d="M0 120c80-40 120 20 210-10 70-24 110 28 190 0 50-18 90 10 240-16v106H0z" />
      <rect className="nt-thumb__card" x="46" y="46" width="150" height="96" rx="16" />
      <path className="nt-thumb__pin" d="M104 62c-14 18-22 30-22 42a22 22 0 0 0 44 0c0-12-8-24-22-42z" />
      <circle cx="104" cy="102" r="6" fill="#fff" />
    </svg>
  );
}

export function ArticleThumb() {
  return (
    <svg className="nt-thumb__svg" viewBox="0 0 640 200" preserveAspectRatio="xMidYMid slice" aria-hidden="true">
      <rect className="nt-thumb__sky" width="640" height="200" />
      <rect className="nt-thumb__page" x="48" y="28" width="200" height="144" rx="16" />
      <rect className="nt-thumb__line" x="72" y="56" width="120" height="12" rx="6" />
      <rect className="nt-thumb__line" x="72" y="80" width="150" height="8" rx="4" />
      <rect className="nt-thumb__line" x="72" y="98" width="136" height="8" rx="4" />
      <rect className="nt-thumb__line" x="72" y="116" width="100" height="8" rx="4" />
    </svg>
  );
}
